import { AbstractSplitUrlDeterminer } from "./SplitUrlDeterminer"
import { SplitUrlMatcher } from "./SplitUrlMatcher"
import { SplitUrlRedirectedCookieStorage } from "./SplitUrlRedirectedCookieStorage"
import HackleCore from "../../core/HackleCore"
import WorkspaceEvaluation from "../../core/internal/workspace/evaluation/WorkspaceEvaluation"
import WorkspaceEvaluationFetcher from "../../core/internal/workspace/evaluation/WorkspaceEvaluationFetcher"
import ExperimentRemoteEvaluateResult from "../../core/internal/workspace/evaluation/entity/ExperimentRemoteEvaluateResult"
import { HackleUser } from "../../core/internal/model/model"

export class RemoteSplitUrlDeterminer extends AbstractSplitUrlDeterminer<
  WorkspaceEvaluation,
  ExperimentRemoteEvaluateResult
> {
  constructor(
    private readonly workspaceEvaluationFetcher: WorkspaceEvaluationFetcher,
    splitUrlMatcher: SplitUrlMatcher,
    splitUrlRedirectedCookieStorage: SplitUrlRedirectedCookieStorage,
    core: HackleCore
  ) {
    super(splitUrlMatcher, splitUrlRedirectedCookieStorage, core)
  }

  protected workspace(user: HackleUser): WorkspaceEvaluation | null {
    return this.workspaceEvaluationFetcher.workspace(user)
  }

  // Split-url candidates are the server results carrying split-url targets; the experiment list
  // is already sorted by the server-assigned order.
  protected splitUrlExperiments(workspace: WorkspaceEvaluation): ExperimentRemoteEvaluateResult[] {
    return workspace.getExperiments().filter((it) => it.targetUrls !== undefined)
  }
}
